import { Component, OnInit } from "@angular/core";

@Component({
  selector: "notfound-page",
  templateUrl: "./notfound-page.component.html",
  styleUrls: ["./notfound-page.component.css"],
  standalone: false,
})
export class NotfoundPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
